"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  var SelectionItemComponent = props.SelectionItemComponent,
      SelectionCheckAllComponent = props.SelectionCheckAllComponent;
  var onChange = props.onChange,
      _props$data = props.data,
      data = _props$data === void 0 ? [] : _props$data,
      value = props.value,
      convertPYs = props.convertPYs,
      starMatch = props.starMatch,
      multiple = props.multiple,
      max = props.max,
      onScroll = props.onScroll,
      html = props.html,
      checkAll = props.checkAll,
      searchCheckAll = props.searchCheckAll,
      checkAllLabel = props.checkAllLabel,
      onCheckAllChange = props.onCheckAllChange,
      checkAllIsChecked = props.checkAllIsChecked,
      dataHtmlRef = props.dataHtmlRef,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      useSearchValue = props.useSearchValue,
      useSearchValueData = props.useSearchValueData,
      propsSearchValueData = props.searchValueData,
      search = props.search,
      searchValue = props.searchValue,
      propsSearchFields = props.searchFields,
      onClickItem = props.onClickItem,
      onSearchFilter = props.onSearchFilter,
      valueFieldName = props.valueFieldName,
      _props$labelFieldName = props.labelFieldName,
      labelFieldName = _props$labelFieldName === void 0 ? '' : _props$labelFieldName,
      emphasize = props.emphasize,
      AppendDataComponent = props.AppendDataComponent,
      _props$classNameMap = props.classNameMap,
      classNameMap = _props$classNameMap === void 0 ? {} : _props$classNameMap;
  var searchFields = typeof propsSearchFields === 'undefined' ? [labelFieldName] : propsSearchFields;
  var searchValueData = [],
      tempData = {},
      checkAllData = {},
      showData = [],
      appendDataComponentInstance = null; // 搜索词数据

  if (useSearchValue || useSearchValueData) {
    tempData = {};
    tempData[labelFieldName] = searchValue;
    tempData[valueFieldName] = searchValue;
    searchValueData = propsSearchValueData || tempData; // searchValueData目前是object，只支持一个需要转成数组

    if (searchValueData && !(0, _spauiUtils.isArray)(searchValueData)) {
      searchValueData = [searchValueData];
    }
  } // 筛选下要展示的数据


  if (!useSearchValueData) {
    data.map(function (item) {
      // 搜索排除
      if (onSearchFilter(item, searchValue, searchFields, convertPYs, search, starMatch)) {
        // 如果有数据的话，就不使用附带的搜索词
        searchValueData = [];
        showData.push(item);
      }

      return item;
    });
  } // 有搜索对应的数据都进行展示且放在最后面


  showData = showData.concat(searchValueData); // 全选对应的文案与值

  checkAllData[labelFieldName] = checkAllLabel;
  checkAllData[valueFieldName] = '';

  if (typeof AppendDataComponent !== 'undefined') {
    if ((0, _spauiUtils.isFunction)(AppendDataComponent)) {
      appendDataComponentInstance = _react["default"].createElement(AppendDataComponent, props);
    } else {
      appendDataComponentInstance = AppendDataComponent;
    }
  }

  return _react["default"].createElement("ul", {
    className: classNameMap.SelectDataClassName,
    onScroll: onScroll,
    ref: dataHtmlRef,
    style: style
  }, multiple && (checkAll || searchCheckAll) && (typeof max === 'undefined' || max < 1) ? _react["default"].createElement(SelectionCheckAllComponent, _extends({}, props, props.SelectionCheckAllComponentProps || {}, {
    classNameMap: classNameMap,
    multiple: multiple,
    checked: checkAllIsChecked,
    data: checkAllData,
    value: value,
    htmlable: html,
    html: html,
    onClick: onCheckAllChange
  })) : null, showData.map(function (item, index) {
    var theItemValue = typeof item[valueFieldName] !== 'undefined' ? item[valueFieldName] : item;

    var onClickSelectItem = function onClickSelectItem(event, itemData, itemValue) {
      if ((0, _spauiUtils.isFunction)(onClickItem)) {
        onClickItem(event, itemData);
      }

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, itemValue);
      }
    };

    return _react["default"].createElement(SelectionItemComponent, _extends({}, props, props.SelectionItemComponentProps || {}, {
      "data-index": index,
      key: theItemValue + '' + index,
      value: value,
      data: emphasize(item, props),
      onClick: function onClick(event) {
        return onClickSelectItem(event, item, theItemValue);
      }
    }));
  }), appendDataComponentInstance);
};

exports["default"] = _default;